import { RouteComponentProps } from "@reach/router";
import { FunctionComponent, lazy } from "react";
import { ErrorBoundary } from "react-error-boundary";
import ErrorFallback from "../shared/ErrorFallback";

interface IParams {
	groupId: number;
	songId: number;
}

interface IProps extends RouteComponentProps<IParams> {
	loggedIn: boolean;
}

const LazyMusic = lazy(() => import(/* webpackChunkName: "Music" */ "./Music"));

const MusicPage: FunctionComponent<IProps> = (props) => {
	// eslint-disable-next-line @typescript-eslint/no-unused-vars
	const { loggedIn, path, groupId, songId } = props;

	if (!loggedIn) {
		return <></>;
	}

	const songIdNum = Number(songId);
	const groupIdNum = Number(groupId);

	return <ErrorBoundary FallbackComponent={ErrorFallback}>
		<LazyMusic groupId={groupIdNum} />
	</ErrorBoundary>;
};

export default MusicPage;